import axios from 'axios'
//<!-- FINAL MEMBER -->
export default {
    getMember(){
        return axios.get('/member?is_active=1'  )
            .then(response => {
                return response.data
            })
    },
    getMemberDataSource(params){
        return axios.get('/member/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getMemberbyID(id){
        return axios.get('/member/' + id)
            .then(response => {
                return response.data
            })
    },    
    createMember(formdata){
        return axios.post('/member', formdata)
            .then(response => {
                return response.data
            })
    },
    updateMember(id,formdata){
        return axios.put('/member/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateMember(id){
        return axios.put('/member/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateMember(id){
        return axios.put('/member/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    getCovenant(id){
        return axios.get('/member/covenant/' + id )
            .then(response => {
                return response.data
            })
    },
    updateCovenant(id,formdata){
        return axios.put('/member/covenant/' + id,formdata )
            .then(response => {
                return response.data
            })
    },
    getBaptism(id){
        return axios.get('/member/baptism/' + id )
            .then(response => {
                return response.data
            })
    },
    updateBaptism(id, formdata){
        return axios.put('/member/baptism/' + id, formdata )
            .then(response => {
                return response.data
            })
    },
    getMarriage(id){
        return axios.get('/member/marriage/' + id )
            .then(response => {
                return response.data
            })
    },
    updateMarriage(id,formdata){
        return axios.put('/member/marriage/' + id,formdata )
            .then(response => {
                return response.data
            })
    },
    getCouple(id){
        return axios.get('/member/couple/' + id )
            .then(response => {
                return response.data
            })
    },
    assign_couple(id,formdata){
        return axios.put('/member/couple/' + id ,formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_couple(id,formdata){
        return axios.put('/member/couple/' + id + '/remove', formdata)
            .then(response => {
                return response.data
            })
    }, 
    assign_icare(id,formdata){
        return axios.put('/member/' + id + '/assign-icare', formdata)
            .then(response => {
                return response.data
            })
    }, 
    assign_icare_youth(id,formdata){
        return axios.put('/member/' + id + '/assign-icare-youth', formdata)
            .then(response => {
                return response.data
            })
    }, 
    assign_department(id,formdata){
        return axios.put('/member/' + id + '/assign-ministry', formdata)
            .then(response => {
                return response.data
            })
    }, 

    //MEMBER NOTE
    getMemberNote(id){
        return axios.get('/member/' + id + '/get-note')
            .then(response => {
                return response.data
            })
    },  
    createMemberNote(id, formdata){
        return axios.post('/member/' + id + '/new-note', formdata)
            .then(response => {
                return response.data
            })
    },
    updateMemberNote(id,formdata){
        return axios.put('/member/' + id + '/update-note', formdata)
            .then(response => {
                return response.data
            })
    }, 
    deleteMemberNote(id){
        return axios.delete('/member/' + id + '/delete-note')
            .then(response => {
                return response.data
            })
    },  

    grantwebaccess(id){
        return axios.get('/grant-web-access/' + id)
            .then(response => {
                return response.data
            })
    },
   
    resetpassword(id){
        return axios.get('/reset-password/' + id)
            .then(response => {
                return response.data
            })
    },

    setpassword(id){
        return axios.put('/set-password/' + id)
            .then(response => {
                return response.data
            })
    },

}